﻿interface Props {
  title: string;
}

export default function PageHeader({ title }: Props) {
  return (
    <div className="page-header">
      <div className="container py-1">
        <h1 className="text-light mb-0">{title}</h1>
      </div>
    </div>
  );
}
